const config = {
  NODE_ENV: process.env.NODE_ENV
}

export default config
